import {
  inspectPaymentProofBytes,
  inspectPaymentProofFileCount,
  PAYMENT_PROOF_DROPZONE_ACCEPT,
  PAYMENT_PROOF_HELPER_TEXT,
  PAYMENT_PROOF_UPLOAD_CONSTRAINTS,
  paymentProofRejectMessage,
} from '@diamond/shared/schema/order';

export const MAX_PAYMENT_PROOF_FILES =
  PAYMENT_PROOF_UPLOAD_CONSTRAINTS.maxFiles;
export const MAX_PAYMENT_PROOF_SIZE_BYTES =
  PAYMENT_PROOF_UPLOAD_CONSTRAINTS.maxBytes;
export const MIN_PAYMENT_PROOF_SIZE_BYTES =
  PAYMENT_PROOF_UPLOAD_CONSTRAINTS.minBytes;
export const PAYMENT_PROOF_ACCEPTED_TYPES = PAYMENT_PROOF_DROPZONE_ACCEPT;
export const PAYMENT_PROOF_HELPER_COPY = PAYMENT_PROOF_HELPER_TEXT;

type PaymentProofFileValidation =
  | { isValid: true }
  | { isValid: false; message: string };

function readFileBytes(file: File): Promise<Uint8Array> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (!(result instanceof ArrayBuffer)) {
        reject(new Error('undecodable_image'));
        return;
      }
      resolve(new Uint8Array(result));
    };
    reader.onerror = () => {
      reject(reader.error);
    };
    reader.readAsArrayBuffer(file);
  });
}

export const validatePaymentProofFiles = async (
  files: File[]
): Promise<PaymentProofFileValidation> => {
  if (files.length === 0) return { isValid: true };

  const countCode = inspectPaymentProofFileCount(files.length);
  if (countCode !== undefined) {
    return {
      isValid: false,
      message: paymentProofRejectMessage(countCode),
    };
  }

  for (const file of files) {
    const bytes = await readFileBytes(file);
    const inspected = inspectPaymentProofBytes(file.name, bytes);
    if (inspected.ok === false) {
      return {
        isValid: false,
        message: paymentProofRejectMessage(inspected.code),
      };
    }
  }

  return { isValid: true };
};
